@if (sessionError()) {
  <twist-session-error-page (signOut)="signOut()"></twist-session-error-page>
} @else {
  <router-outlet></router-outlet>
  @if (loading()) {
    <ui-loading [showLogo]="true"></ui-loading>
  }
}
<tw-toast-viewport></tw-toast-viewport>
